import styles from "./player-progress.module.css";

export const ProgressSlider = "div";
export const ProgressSliderClassName = styles.progressSlider;

export const TipContainer = "div";
export const TipContainerClassName = styles.tipContainer;
export const TipContainerVisibleClassName = styles.tipContainerVisible;
export const TipContainerHiddenClassName = styles.tipContainerHidden;

export const TipContent = "p";
export const TipContentClassName = styles.tipContent;
